import { Article } from "../../../types";

export const SET_HELP_CENTER_STATE = "SET_HELP_CENTER_STATE";

export interface HelpCenterState {
  isFetching: boolean;
  search: string;
  articles: Article[];
}

export interface SetHelpCenterStateAction {
  type: typeof SET_HELP_CENTER_STATE;
  state: HelpCenterState;
}

export type HelpCenterActionTypes = SetHelpCenterStateAction;
